import { Foundation } from "foundation-sites/js/foundation.core";
import { Accordion } from "foundation-sites/js/foundation.accordion";

Foundation.plugin(Accordion, "Accordion");

Foundation.addToJquery($);

$(document).foundation();
